import { IOption } from '../../../common/common.types'
import { IOtherAgency } from '../store/sceneDescription.types'

export const getCodedValue = (agencyName: IOption | null): number | null => {
  if (!agencyName) return null

  if ((agencyName.id as unknown as string).charAt(0).toLowerCase() === 'e') {
    const codedStr = (agencyName.id as unknown as string).substring(1)
    if (Number.isNaN(codedStr)) return null

    return Number(codedStr)
  }

  return null
}

export const getUnitIdValue = (agencyName: IOption | null): number | null => {
  if (!agencyName) return null

  if ((agencyName.id as unknown as string).charAt(0).toLowerCase() === 'u') {
    const unitIdStr = (agencyName.id as unknown as string).substring(1)
    if (Number.isNaN(unitIdStr)) return null

    return Number(unitIdStr)
  }

  return null
}

export const otherAgencyIsNonEmpty = (otherAgency: IOtherAgency): boolean => {
  return (
    !!otherAgency.agencyName ||
    !!otherAgency.agencyType ||
    !!otherAgency.agencyNumber ||
    !!otherAgency.firstOnScene ||
    !!otherAgency.firstOnScenePNNV
  )
}
